// client/src/components/world/StructureViewer.jsx
// Итерация 9.6: общий вьювер структуры.
//
// Режимы:
//   - mode="object"     → <SummaryMesh> (вся структура, свободная камера).
//   - mode="character"  → <InteriorVisualizer> (фильтр по палубе + радиусу).
//
// Используется в:
//   - WorldScene (mode из GameClient).
//   - AssetManager (mode="object").
//
// Контракт:
//   <StructureViewer
//     type="ship"            // тип структуры (опционально)
//     id="..."               // ID структуры (опционально)
//     mode="object"          // "object" | "character"
//     summaryMesh={mesh}     // для mode="object" (от useSummaryMesh)
//     installedModules={[]}  // для mode="character"
//     currentDeckId={null}   // для mode="character"
//     characterPosition={null} // для mode="character"
//     visibilityRadius={50}  // для mode="character"
//     distance={0}           // для LOD (mode="object")
//     fallback={null}        // если нет данных
//   />

import React from 'react';
import SummaryMesh from './SummaryMesh';
import InteriorVisualizer from './InteriorVisualizer';

export default function StructureViewer({
  type,
  id,
  mode = 'object',
  summaryMesh = null,
  installedModules = [],
  currentDeckId = null,
  characterPosition = null,
  visibilityRadius = 50,
  distance = 0,
  fallback = null,
}) {
  // Режим «Объект» — вся структура через SummaryMesh
  if (mode === 'object') {
    if (summaryMesh) {
      return (
        <SummaryMesh
          summaryMesh={summaryMesh}
          distance={distance}
          fallback={fallback}
        />
      );
    }

    // Fallback: если нет summaryMesh, но есть модули — показываем InteriorVisualizer без фильтра
    if (Array.isArray(installedModules) && installedModules.length > 0) {
      return (
        <InteriorVisualizer
          installedModules={installedModules}
          currentDeckId={null}       // без фильтра по палубе
          characterPosition={null}   // без фильтра по позиции
          visibilityRadius={null}    // без фильтра по радиусу
        />
      );
    }

    return fallback;
  }

  // Режим «Персонаж» — только ближайшие модули
  if (mode === 'character') {
    if (!Array.isArray(installedModules) || installedModules.length === 0) {
      return fallback;
    }

    return (
      <InteriorVisualizer
        installedModules={installedModules}
        currentDeckId={currentDeckId}
        characterPosition={characterPosition}
        visibilityRadius={visibilityRadius}
      />
    );
  }

  return fallback;
}